import styled, { CSSObject } from '@emotion/styled';
import { alpha } from '@mui/material/styles';

export const DroppableContainer = styled.div(
  ({ theme }): CSSObject => ({
    backgroundColor: theme.palette.secondary.light,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem 0.5rem',
    overflow: 'hidden',
  }),
);

export const SlidesScrollArea = styled.div(
  ({ theme }): CSSObject => ({
    flex: 1,
    overflowY: 'auto',
    minHeight: 0,
    marginRight: '-0.5rem',
    scrollbarWidth: 'thin',
    scrollbarColor: `${alpha(theme.palette.primary.main, 0.5)} ${theme.palette.secondary.light}`,
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.palette.secondary.light,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: alpha(theme.palette.primary.main, 0.5),
      borderRadius: '2px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  }),
);

export const AddSlideButtonWrapper = styled.div(
  (): CSSObject => ({
    marginTop: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
  }),
);